import moment from "moment";
import DateFormat from "src/listingScreen/agGridDateFormat";

const fields = {
  fileListFields: [
    // { key: 'sNo', label:'S.No' },
    { key: "fileName", label: "Filename" },
    { key: "createBy", label: "Uploaded By"},
    { key: "createDate", label: "Upload Date" },
    { key: "documentRemarks", label: "Remarks" },
  ],
  supplierListFields: [
    // { key: 'referenceNo', label:'Ref No' },
    { key: "quotationDate", label: "Quote Date" },
    { key: "vendorCode", label: "Vendor Code" },
    { key: "vendorName", label: "Vendor Name", sorter: false, filter: true },
    { key: "quotationNo", label: " Quotation No", sorter: false, filter: true , _style: {textAlign: "left",width:"10%"}},
    { key: "currencyCode", label: " Currency"},
    // { key: "exRate", label: " ExRate"},
    { key: "totalAmtAftDiscount", label: "Amount" },
    { key: "processStatusDesc", label: "Status" },
    { key: "rejectRemarks", label: "Reject Remarks", _style: {display:"none", width:"20%"},},
    {
      key: "show_details",
      label: "",
      sorter: false,
      filter: false,
    },
    { 
    key: "isQuotationReleased", 
    label: "Release Quotation",
    sorter: false,
    filter: false, 
    _style: {textAlign: "center",display:"none"},
   },
  ],
  approvalCenter: {
    waitingForApproval: [
      { key: "trxDate", label: "Date" },
      { key: "documentNo", label: "Q.no" },
      { key: "vendorName", label: "Vendor" },
      { key: "brageName", label: "Vessel" },
      {
        key: "ReferenceNo",
        label: "Ref No",
        sorter: false,
        filter: false,
      },
      { key: "currency", label: "Currency" },
      { key: "totalAmount", label: "Amount" },
      { key: "processStatusDesc", label: "Status" },
      {
        key: "select_checkBox",
        filter: false,

        label: <input type="checkbox" id="details-checkbox"></input>,
      },
    ],
  },
  requisition: {
    list: [
      { key: "requisitionNo", label: "Req No",_style: {width: "15%"} },
      { key: "bargeName", label: "Vessel",_style: {width: "13%"} },
      { key: "referenceNo", label: "Ref No",_style: {width: "20%"}},
      { key: "requisitionDate", label: "Req date",_style: {width: "10%"} },
      { key: "remarks", label: "Remarks",_style: {width: "20%"} },
      // { key: "createBy", label: "Create By" },
      // { key: "editBy", label: "Edited By" },
      { key: "statusCode", label: "Status",_style: {width: "11%"} },
      { key: "processStatusDesc", label: "Process Status",_style: {width: "11%"} },
      // { key: "docCount", label: "Doc Count" },
      {
        key: "show_details",
        label: "",
        sorter: false,
        filter: false,
      },
    ],
    newQuotationList:[
      { key: "requisitionNo", label: "Req No",_style: {width: "15%"} },
      { key: "bargeName", label: "Vessel",_style: {width: "15%"} },
      { key: "requisitionDate", label: "Req date",_style: {width: "10%"} },
      { key: "referenceNo", label: "Ref No",_style:{width:"20%"}},
      { key: "remarks", label: "Remarks" },
      // { key: "createBy", label: "Create By",_style: {width: "20%"} },
      // { key: "editBy", label: "Edited By",_style: {width: "15%"} },
      // { key: "docCount", label: "Doc Count",_style: {width: "10%"} },
      {
        key: "show_details",
        label: "",
        sorter: false,
        filter: false,
      },
    ],
    iMPAitems: [
      { key: "serialNo", label: "S.No",_style: {width: "4%"} },
      { key: "iMPACode", label: "Code/Part No",_style: {width: "10%"}},
      { key: "description", label: "Description", _style: { width: "50%" } },
      { key: "requestedQty", label: "Req Qty",_style: {width: "6%"}},
      { key: "requestedUOM", label: "Req UOM",_style: {width: "6%"}},
      { key: "mainCode", label: "GL Code" },
      { key: "remarks", label: "Remarks" },
      // { key: "approvedQty", label: "Approved Qty" },
      // { key: "approvedUOM", label: "Approved UOM" }
      {
        key: "show_details",
        label: "",
        sorter: false,
        filter: false,
      },
    ],
    partitems: [
      { key: "serialNo", label: "S.No",_style: {width: "4%"} },
      { key: "partNo", label: "Code/Part No",_style: {width: "10%"}},
      { key: "description", label: "Description", _style: { width: "40%" } },
      { key: "requestedQty", label: "Req Qty",_style: {width: "6%"}},
      { key: "requestedUOM", label: "Req UOM",_style: {width: "6%"}},
      { key: "mainCode", label: "GL Code" },
      { key: "remarks", label: "Remarks" },
      // { key: "approvedQty", label: "Approved Qty" },
      // { key: "approvedUOM", label: "Approved UOM" }
      {
        key: "show_details",
        label: "",
        sorter: false,
        filter: false,
      },
    ],
    ImportImpaFailure: [
      { width: 105, field: "serialNo", headerName: "S.No", },
      { width: 160, field: "iMPACode", headerName: "Code/Part No", },
      { width: 400, field: "description", headerName: "Description",tooltipField: "description" },
      { width: 130, field: "requestedQty", headerName: "Req Qty" },
      { width: 140, field: "requestedUOM", headerName: "Req UOM" },
      { width: 130, field: "mainCode", headerName: "GL Code" },
      { width: 400, field: "remarks", headerName: "Remarks",tooltipField: "remarks" },
      { width: 200, field: "failureRemarks", headerName: "Failure Remarks", pinned:"right",tooltipField: "failureRemarks" },
    ],
    ImportSparePartsFailure: [
      { width: 105, field: "serialNo", headerName: "S.No", },
      { width: 160, field: "partNo", headerName: "Code/Part No", },
      { width: 400, field: "description", headerName: "Description",tooltipField: "description" },
      { width: 130, field: "requestedQty", headerName: "Req Qty" },
      { width: 140, field: "requestedUOM", headerName: "Req UOM" },
      { width: 130, field: "mainCode", headerName: "GL Code" },
      { width: 400, field: "remarks", headerName: "Remarks",tooltipField: "remarks" },
      { width: 200, field: "failureRemarks", headerName: "Failure Remarks", pinned:"right",tooltipField: "failureRemarks" },
    ],
  },
  vendorListFields: [
    { key: "vendorCode", label: "Vendor Code" },
    { key: "vendorName", label: "Vendor Name" },
    { key: "contact", label: "Contact" },
    { key: "email", label: "Email" },
    { key: "currencyCode", label: "Currency" },
    // { key: 'sentDate', label:'Sent Date' },
    // { key: 'remarks', label:'Remarks' },
    { key: "sentStatus", label: "Status" },
    {
      key: "show_details",
      label: "",
      sorter: false,
      filter: false,
    },
  ],

  supplierQuotation: {
    list: [
      { key: "quotationNo", label: "Quote No", _style: { width: "11%" } },
      { key: "requisitionNo", label: "Req No", _style: { width: "11%" } },
      { key: "bargeName", label: "Vessel" },
      // { key: 'VesselDepartmentId', label:'Vessel Department' },
      // { key: 'vendorCode', label:'Vendor Code' },
      { key: "vendorName", label: "Vendor", _style: { width: "12%" } },
      { key: "currencyCode", label: "Curr" },
      { key: "totalAmtAftDiscount", label: "Amt Aft Disc" },
      { key: "referenceNo", label: "Ref No" },
      { key: "remarks", label: "Remarks", _style: { width: "12%" } },
      { key: "quotationDate", label: "Quote Date" },
      { key: "validityDate", label: "Validity" },
      // { key: 'quotationId', label:'Lic No' },
      // { key: "createBy", label: "Create By" },
      // { key: "editBy", label: "Edited By" },
      { key: "editVersion", label:"Edit Version"},
      { key: "pmsStatusName", label: "Status" },
      { key: "processStatusDesc", label: "Process Status" },
      // { key: "docCount", label: "Doc Count" },
      {
        key: "show_details",
        label: "",
        sorter: false,
        filter: false,
      },
    ],
    iMPAitems: [
      { key: "serialNo", label: "S.No" },
      { key: "iMPACode", label: "IMPA Code" },
      { key: "description", label: "Description", _style: { width: "20%" } },
      { key: "requestedQty", label: "Req Qty" },
      { key: "uOMName", label: "Req UOM" },
      { key: "availableQty", label: "Avail Qty" },
      { key: "price", label: "Unit Price" },
      { key: "amt", label: "Amount" },
      { key: "discountPercentage", label: "Dis. %" },
      { key: "discountAmt", label: "Disc. Amt" },
      { key: "remarks", label: "Remarks" },
      {
        key: "show_details",
        label: "",
        sorter: false,
        filter: false,
      },
    ],
    partitems: [
      { key: "serialNo", label: "S.No" },
      { key: "partNo", label: "Part No" },
      { key: "description", label: "description", _style: { width: "20%" } },
      { key: "requestedQty", label: "Requested Qty" },
      { key: "uOMName", label: "Requested UOM" },
      { key: "availableQty", label: "Avail Qty" },
      { key: "price", label: "Unit Price" },
      { key: "amt", label: "Amount" },
      { key: "discountPercentage", label: "Dis. %" },
      { key: "discountAmt", label: "Disc. Amt" },
      { key: "remarks", label: "Item Remarks" },
      {
        key: "show_details",
        label: "",
        sorter: false,
        filter: false,
      },
    ],
  },

  // Delivery Order

  deliveryOrder: {
    list: [
      { key: "purchaseOrderNo", label: "PO No", _style: { width: "12%" } },
      { key: "inquiryQuoteNo", label: "Quote No", _style: { width: "12%" } },
      { key: "requisitionNo", label: "Req No", _style: { width: "12%" } },
      { key: "admBargeName", label: "Vessel", _style: { width: "8%" } },
      //{ key: "admBargeIsThirdParty", label: "Third Party Vessel", _style: { width: "12%" } },
      { key: "vendorName", label: "Vendor", _style: { width: "10%" } },
      { key: "referenceNo", label: "Ref No", _style: { width: "10%" } },
      { key: "remarks", label: "Remarks", _style: { width: "10%" } },
      { key: "purchaseOrderDate", label: "PO Date", _style: { width: "5%" } },
      { key: "currencyCode", label: "Curr", _style: { width: "5%" } },
      { key: "totalAmt", label: "Total Amt", _style: { width: "5%" } },
      { key: "pmsStatusCode", label: "Status", filter: { statusId: "5" }, _style: { width: "9%" } },
      {
        key: "show_details",
        label: "",
        sorter: false,
        filter: false,
      },
    ],
    iMPAitems: [
      { key: "sno", label: "S.No" },
      { key: "mainCode", label: "GL Code" },
      { key: "description", label: "Description" },
      { key: "deliveryQty", label: "Delivery Qty" },
      { key: "uOM", label: "UOM" },
      { key: "price", label: "Price" },
      { key: "amt", label: "Amt" },
      { key: "localAmt", label: "Local Amt" },
      { key: "remarks", label: "Remarks" },
      {
        key: "show_details",
        label: "",
        sorter: false,
        filter: false,
      },
    ],
    partitems: [
      { key: "serialNo", label: "S.No" },
      { key: "partNo", label: "Part No" },
      { key: "description", label: "Description", _style: { width: "30%" } },
      { key: "requestedQty", label: "Requested Qty" },
      { key: "requestedUOM", label: "Requested UOM" },
      { key: "approvedQty", label: "Approved Qty" },
      { key: "approvedUOM", label: "Approved UOM" },
      {
        key: "show_details",
        label: "",
        sorter: false,
        filter: false,
      },
    ],
    newDelieveryOrder: [
      { key: "IMPACodeId", label: "IMPA Code" },
      { key: "Description", label: "Description" },
      { key: "POQty", label: "Po Qty" },
      { key: "DeliveredQty", label: "Delieverd Qty" },
      { key: "UOMId", label: "UOM" },
      { key: "Price", label: "Price" },
      { key: "LocalAmt", label: "Amt" },
    ],
    listOfDelieveryOrders: [
      { key: "deliveryOrderNo", label: "DO.No", _style: { width: "12%" } },
      { key: "purchaseOrderNo", label: " PO.No", _style: { width: "12%" } },
      { key: "admBargeName", label: "Vessel", _style: { width: "8%" } },
      //{ key: "admBargeIsThirdParty", label: "Third Party Vessel", _style: { width: "12%" } },
      { key: "vendorName", label: "Vendor", _style: { width: "8%" } },
      { key: "deliveryDate", label: "DO.Date", _style: { width: "8%" } },
      { key: "referenceNo", label: "Ref No", _style: { width: "10%" } },
      { key: "remarks", label: "Remarks", _style: { width: "11%" } },
      { key: "pmsStatusCode", label: "Status", _style: { width: "8%" } },
      { key: "processStatusDesc", label: "Process Status", _style: { width: "8%" } },
      { key: "currencyCode", label: "Curr", _style: { width: "5%" } },
      { key: "totalAmtAftGst", label: "Total Amt Aft GST", _style: { width: "8%" } },
      {
        key: "show_details",
        label: "",
        sorter: false,
        filter: false,
      },
    ],
    masterPriceList: [
      { key: "supplierContractNo", label: "MPL.No", _style: { width: "15%" } },
      { key: "contractCategoryName", label: "Category" , _style: { width: "15%" }},
      { key: "vendorName", label: "Vendor" , _style: { width: "15%" }},
      { key: "vesselName", label: "Vessel" , _style: { width: "15%" }},
      // { key: "createBy", label: "Create By" , _style: { width: "10%" }},
      // { key: "editBy", label: "Edited By" , _style: { width: "10%" }},
      { key: "remarks", label: "Remarks", _style: { width: "26%" } },
      { key: "trxDate", label: "Date" , _style: { width: "7%" }},
      { key: "expiryDate", label: "Expiry Date", _style: { width: "7%" }},
      // { key: "docCount", label: "Doc Count" , _style: { width: "2%" }},
      {
        key: "show_details",
        label: "",
        sorter: false,
        filter: false,
      },
    ],

    listofQoutations: [
      { key: "contractQuotationNo", label: "Quotation No" },
      { key: "contractCategoryName", label: "Category" },
      { key: "vendorName", label: "Vendor" },
      { key: "admBargeName", label: "Vessel" },
      { key: "trxDate", label: "Date" },
      { key: "currencyCode", label: "Curr" },
      { key: "totalAmt", label: "Total Amt" },
      // { key: "createBy", label: "Create By" },
      // { key: "editBy", label: "Edited By" },
      { key: "remarks", label: "Remarks" },
      { key: "pmsStatusCode", label: "Status" },
      { key: "processStatusDesc", label: "Process Status" },
      // { key: "docCount", label: "Doc Count" },
      // { key: "pmsstatusCode", label: "Status" },
      {
        key: "show_details",
        label: "",
        sorter: false,
        filter: false,
      },
    ],
  },

  // Purchase Order

  purchaseOrder: {
    iMPAitems: [
      { key: "serialNo", label: "S. No" },
      {key: "itemNo", label: "Item NO"},
      { key: "code", label: "Code" },
      { key: "description", label: "Description" },
      { key: "uomCode", label: "UOM" },
      { key: "mainCode", label: "GL Code" },
      { key: "qty", label: "Qty" },
      { key: "actualPrice", label: "Unit Price" },
      { key: "amt", label: "Amt" },
      {key: "discountAmt",label:"Disc Amt"},
      { key: "amtAftDiscount", label: "Amt Aft Disc" },
      // { key: "gSTAmt", label: "GST" },
      // { key: 'gSTPercentage', label:'GST %'  },
      // { key: "gSTAmt", label: "GST Amt" },
      // { key: "mainCodeId", label: "GL Code" },
      { key: "remarks", label: "Remarks" },
      {
        key: "lastPurchasePriceInfo",
        label: "L.P.P",
        sorter: false,
        filter: false,
      },
      {
        key: "show_details",
        label: "",
        sorter: false,
        filter: false,
      },
    ],
    woiMPAitems: [
      { key: "serialNo", label: "S. No",_style: {width: "5%"} },
      {key: "itemNo", label: "Item No",_style: {width: "6%"}},
      { key: "code", label: "Code" },
      { key: "description", label: "Description", _style: { width: "30%" } },
      { key: "uomCode", label: "UOM" },
      { key: "mainCode", label: "GL Code" },
      { key: "qty", label: "Qty" },
      { key: "actualPrice", label: "Unit Price" },
      { key: "amt", label: "Amt" },
      {key: "discountAmt",label:"Disc Amt"},
      { key: "amtAftDiscount", label: "Amt Aft Disc" },
      // { key: "gSTAmt", label: "GST Amt" },
      { key: "remarks", label: "Remarks" },
      {
        key: "lastPurchasePriceInfo",
        label: "L.P.P",
        sorter: false,
        filter: false,
      },
      {
        key: "show_details",
        label: "",
        sorter: false,
        filter: false,
      },
    ],
    vendoriMPAitems: [
      { key: "serialNo", label: "S. No" }, // $erialNumber
      { key: "code", label: "Code" },
      { key: "description", label: "Description" },
      { key: "uomCode", label: "UOM" },
      { key: "mainCode", label: "GL Code" },
      { key: "qty", label: "Qty" },
      { key: "actualPrice", label: "Unit Price" },
      { key: "amt", label: "Amt" },
      {key: "discountAmt",label:"Disc Amt"},
      { key: "amtAftDiscount", label: "Amt Aft Disc" },
      { key: "remarks", label: "Remarks" },
    ],
    list: [
      { key: "purchaseOrderNo", label: "PO No", _style: { width: "25%" } },
      { key: "inquiryQuoteNo", label: "Quote No", _style: { width: "25%" } },
      { key: "requisitionNo", label: "Req No", _style: { width: "25%" } },
      { key: "admBargeName", label: "Vessel", _style: { width: "7%" } },
      //{ key: "admBargeIsThirdParty", label: "Third Party Vessel", _style: { width: "25%" } },
      { key: "vendorName", label: "Vendor", _style: { width: "7%" } },
      { key: "referenceNo", label: "Ref No", _style: { width: "5%" } },
      { key: "eta", label: "ETA", _style: { width: "8%" } },
      { key: "remarks", label: "Remarks",_style: { width: "8%" } },
      { key: "purchaseOrderDate", label: "PO Date", _style: { width: "5%" } },
      { key: "currencyCode", label: "Curr", _style: { width: "5%" } },
      // { key: 'requisitionNo', label:'Req No' },

      // { key: 'vendorCode', label:'Vendor Code' },

      // { key: 'CreateDate', label:'Quotation Date' },
      // { key: 'trxDate', label:'Validity Date' },
      // { key: 'quotationId', label:'Lic No' },
      // { key: "currencyCode", label: "Currency" },

      { key: "totalAmtAfterGST", label: "Total Amt", _style: { width: "5%" } },
      // { key: "createBy", label: "Create By" },
      // { key: "editBy", label: "Edited By" },
      { key: "approvedBy", label: "Approved By", _style: { width: "5%" }},
      { key: "approvedDate", label: "Approved Date", _style: { width: "5%" }},
      { key: "pmsStatusCode", label: "Status", filter: { statusId: "5%" } },
      { key: "processStatusDesc", label: "Process Status",_style: { width: "7%" } },
      // { key: "docCount", label: "Doc Count" },
      {
        key: "show_details",
        label: "",
        sorter: false,
        filter: false,
      },
    ],
    batchProcess: [
      { key: "purchaseOrderNo", label: "PurchaseOrderNo ", _style: { width: "9%"} },
      { key: "inquiryQuoteNo", label: "QuotationNo", _style: { width: "9%" } },
      { key: "requisitionNo", label: "RequisitionNo", _style: { width: "9%" } },
      { key: "admBargeName", label: "Vessel",_style: { width: "7%" } },
      { key: "breakVendorName", label: "Vendor", _style: { width: "12%" } },
      { key: "referenceNo", label: "Ref No", _style: { width: "10%" } },
      { key: "newpurchaseOrderDate", label: "PO Date", _style: { width: "2%" } },
      { key: "totalAmt", label: "Total Amt", _style: { width: "5%" } },
      { key: "createBy", label: "Create By", _style: { width: "6%" } },
      { key: "editBy", label: "Edited By", _style: { width: "6%" } },
      { key: "approvedBy", label: "Approved By", _style: { width: "2%" }},
      { key: "newapprovedDate", label: "Approved Date", _style: { width: "2%" }},
      // { key: "pmsStatusCode", label: "Status", filter: { statusId: "5" } },
      { key: "processStatusDesc", label: "Process Status", _style: { width: "8%" } },
      { key: "docCount", label: "Doc Count", _style: { width: "2%" } },
      {
        key: "select_checkBox",
        filter: false,
  
        label: <input type="checkbox" id="details-checkbox"></input>,
      },
    ],
  },
  employeeCashClaims: {
    cashclaimslist: [
     
      // { key: "EmployeeId", label: "EmployeeId", _style: { width: "11%" } },
      { key: "employeeClaimNo", label: "EmployeeClaimNo", _style: { width: "11%" } },
      { key: "employeeName", label: "Requested By", _style: { width: "11%" } },
      { key: "trxDate", label: "TrxDate", _style: { width: "11%" } },
      { key: "currencyId", label: "CurrencyId",type: 'numericColumn' },
      { key: "pmsStatusCode", label: "Status", _style: { width: "15%" } },
      { key:"createBy", label: "CreateBy"},
      { key: "editBy", label: "Edited By", _style: { width: "5%" } },
      { key: "claimedBy", label: "ClaimedBy" },
      {
        key: "show_details",
        label: "",
        sorter: false,
        filter: false,
      },
    ],
  },

  employeeVendorClaims: {
    vendorclaimslist: [
     
      { key: "empVendorClaimNo", label: "EmpVendorClaimNo", _style: { width: "11%" } },
      { key: "vendorName", label: "Vendor", _style: { width: "11%" } },
      { key: "trxDate", label: "TrxDate", _style: { width: "11%" } },
      { key: "pmsStatusCode", label: "Status" },
      { key: "vendorInvoiceNo", label: "Vendor Invoice No", _style: { width: "15%" } },
      { key: "referenceNo", label: "Ref No", _style: { width: "5%" } },
      { key:"createBy", label: "CreateBy"},
      { key: "editBy", label: "EditedBy" },
      { key: "claimedBy", label: "ClaimedBy   " },
      {
        key: "show_details",
        label: "",
        sorter: false,
        filter: false,
      },
    ],
  },

  categoryMasterHeader: [
    { field: "contractCategoryCode", headerName: "Category Code", width: 380 },
    { field: "contractCategoryName", headerName: "Category Name", width: 450 },
    { field: "mainCode", headerName: "GL Code" , width: 130 },
    { field: "isActiveStatue", headerName: "Active", width: 120  },
    { field: "createBy", headerName: "Created By" , width: 200 },
    { 
      width: 200, 
      field: "createDate", 
      headerName: "Created Date",
      cellRenderer: (data) => {
          return moment(data.value).format('DD/MM/YYYY')
      }},
    // { field: "createDate", headerName: "Created Date" , width: 160 },
    // { field: "editBy", headerName: "Edited By", width: "5%"  },
    // { field: "oldEditDate", headerName: "Edited Date" , _style: { width: "5%" }},
    // { field: "contractCategoryId", headerName: "Category Id",type: 'numericColumn', _style: { width: "5%" } },
  ],

  impaCodeMasterHeader: [
    { width:180,field: "iMPACode", headerName: "IMPA Code" },
    { width:600,field: "iMPACategoryDescription", headerName: "Description" },
    { width:160,field: "iMPACategoryCode", headerName: "Category" },
    { width:120,field: "uomCode", headerName: "UOM"},
    { width:200,field: "remarks", headerName: "Remarks" },
    { width:120,field: "isActiveStatue", headerName: "Active"},
    { width:200,field: "createBy", headerName: "Created By" },
    { 
      width: 200, 
      field: "createDate", 
      headerName: "Created Date",
      cellRenderer: (data) => {
          return moment(data.value).format('DD/MM/YYYY')
      }},
    // { field: "editBy", headerName: "Edited By" },
    // { field: "oldEditDate", headerName: "Edited Date" },
    // { field: "iMPACodeId", headerName: "IMPA Code Id",type: 'numericColumn' }
  ],
impaCategoryHeader:[
  { field: "iMPACategoryCode", headerName: "Category Code",width: 200 },
  { field: "iMPACategoryName", headerName: "Category Name",width: 300 },
  { field: "mainCode", headerName: "GL Code",width:130 },
  { field: "remarks", headerName: "Remarks" ,width: 320},
  { field: "isActiveStatue", headerName: "Active",width:120},
  { field: "createBy", headerName: "Created By",width:200 },
  { 
    width: 200, 
    field: "createDate", 
    headerName: "Created Date",
    cellRenderer: (data) => {
        return moment(data.value).format('DD/MM/YYYY')
    }},
   
  // { field: "editBy", headerName: "Edited By" },
  // { field: "oldEditDate", headerName: "Edited Date" },
  // { field: "iMPACategoryId", headerName: "Category Id",type: 'numericColumn' },
],
equipmentCategory:[
  {field:"categoryCode", headerName: "Category Code"},
  {field:"categoryName", headerName: "Category Name"},
  { field: "remarks", headerName: "Remarks" ,width: 320},
  { field: "isActiveStatue", headerName: "Active",width:120},
  { field: "createBy", headerName: "Created By",width:200 },
  { 
    width: 200, 
    field: "createDate", 
    headerName: "Created Date",
    cellRenderer: (data) => {
        return moment(data.value).format('DD/MM/YYYY')
    }},

],
creditTermHeader:[
  { field: "creditTermCode", headerName: "Credit Term Code",width: 220 },
  { field: "creditTermName", headerName: "Credit Term Name" ,width: 300},
  { field: "noOfDays", headerName: "No Of Days", type: 'numericColumn',width: 150},
  { field: "isActiveStatue", headerName: "Is Active", width:130 },
  { field: "createBy", headerName: "Create By",width:200 },
  // { field: "editBy", headerName: "Edit By" },
  // { field: "oldEditDate", headerName: "Edit Date" },
  // { field: "branchId", headerName: "Branch Id",type: 'numericColumn', _style: { width: "20%"} },
  { field: "remarks", headerName: "Remarks", width:260 },
  { field: "createDate", headerName: "Create Date",width:150,cellRenderer: (data) => {
    return moment(data.value).format('DD/MM/YYYY');
} },
  // { field: "termId", headerName: "Term Id",type: 'numericColumn', _style: { width: "20%" } },
],
employeCategoryHeader:[ 
  { width: 400, field: "categoryCode", headerName: "Category Code"},
  { width: 450, field: "categoryName", headerName: "Category Name"},
  // { width: , field: "remarks", headerName: "Remarks" },
  { width: 120, field: "isActiveStatue", headerName: "Active"},
  { width: 300, field: "createBy", headerName: "Created By" },
  { width: 180, field: "createDate", headerName: "Created Date",cellRenderer: (data) => {
    return moment(data.value).format('DD/MM/YYYY');
} },
  // { width: 180, field: "oldCreateDate", headerName: "Created Date" },
  // { field: "editBy", headerName: "Edited By" },
  // { field: "oldEditDate", headerName: "Edited Date" },
  // { field: "categoryId", headerName: "Category Id" },
],
vendorListHeaders:[
  { field: "vendorCode", headerName: "Vendor Code" },
  { field: "vendorName", headerName: "Vendor Name" },
  { field: "remarks", headerName: "Remarks" },
  // { field: "defaultGstId", headerName: "GST ID"},
  // { field: "currencyId", headerName: "Currency ID"},
  { field: "isActiveStatue", headerName: "Active"},
  { field: "createBy", headerName: "Created By" },
  { field: "oldCreateDate", headerName: "Created Date" },
  { field: "editBy", headerName: "Edited By" },
  { field: "oldEditDate", headerName: "Edited Date" },
  { field: "vendorId", headerName: "Vendor Id",type: 'numericColumn' },
],

vendorPICHeaders:[
  { key: "contact", label: "Contact Person" },
  { key: "telephoneNo", label: "Telephone No" },
  { key: "mobileNo", label: "Mobile No" },
  { key: "email", label: "Email"},
 
],

reasonForAwardingListHeaders:[
  { width: 170, field: "rewardCode", headerName: "Reward Code" },
  { width: 400, field: "rewardDescription", headerName: "Description",tooltipField:"rewardDescription",tooltipShowDelay: 0, },
  { width: 170, field: "createBy", headerName: "Created By" },
  { 
    width: 170, 
    field: "createDate", 
    headerName: "Created Date",
    cellRenderer: (data) => {
        return moment(data.value).format('DD/MM/YYYY')
    }},
    { width: 170, field: "editBy", headerName: "Edit By" },
  { 
    width: 170, 
    field: "editDate", 
    cellRendererFramework: DateFormat,
    headerName: "Edit Date",
    // 
  },
  { width: 120, field: "isActiveStatue", headerName: "Active"},
  
],

mainCodeMasterListHeaders:[
  { width: 170, field: "mainCode", headerName: "GL Code" },
  { width: 400, field: "mainCodeDescription", headerName: "GL Code Desc" },
  { width: 450, field: "remarks", headerName: "Remarks" },
  { width: 120, field: "isActiveStatue", headerName: "Active"},
  { width: 200, field: "createBy", headerName: "Created By" },
  { 
    width: 200, 
    field: "createDate", 
    headerName: "Created Date",
    cellRenderer: (data) => {
        return moment(data.value).format('DD/MM/YYYY')
    }},
  // { field: "editBy", headerName: "Edited By" },
  // { field: "oldEditDate", headerName: "Edited Date" },
  // { field: "mainCodeId", headerName: "GL Code Id",type: 'numericColumn' },
],
vesselMasterListHeaders:[
  { width: 200, field: "bargeCode", headerName: "Vessel Code" },
  { width: 300, field: "bargeName", headerName: "Vessel Name" },
  { width: 180, field: "vesselSuffix", headerName: "Vessel Suffix" },
  { width: 180, field: "callSign", headerName: "Call Sign" },
  { width: 180, field: "licenseNo", headerName: "Licence NO" },
  { width: 120, field: "isActiveStatue", headerName: "Active"},
  { width: 120, field: "isThirdPartyStatus", headerName: "Third Party"},
  { width: 200, field: "createBy", headerName: "Created By" },
  { 
    width: 200, 
    field: "createDate", 
    headerName: "Created Date",
    cellRenderer: (data) => {
        return moment(data.value).format('DD/MM/YYYY')
    }
},
  // { width: 200, field: "createDate", headerName: "Created Date" },
  // { field: "editBy", headerName: "Edited By" },
  // { field: "oldEditDate", headerName: "Edited Date" },
  // { field: "bargeId", headerName: "Vessel Id",type: 'numericColumn' },
],
employeeMasterListHeaders:[
  { width:350 , field: "employeeCode", headerName: "Employee Code" },
  { width: 550, field: "employeeName", headerName: "Employee Name" },
  { width: 120, field: "isActiveStatue", headerName: "Active"},
  { width: 300, field: "createBy", headerName: "Created By" },
  {
    field: "createDate", headerName: "Create Date", width: 350, cellRenderer: (data) => {
        return moment(data.value).format('DD/MM/YYYY');
    }
  },
  // { field: "editBy", headerName: "Edited By" },
  // { field: "oldEditDate", headerName: "Edited Date" },
  // { field: "employeeId", headerName: "Employee Id",type: 'numericColumn' },
],
UOMMasterListHeaders:[
  { width: 340, field: "uomCode", headerName: "UOM Code" },
  { width: 520, field: "uomName", headerName: "UOM Name" },
  { width: 150, field: "isActiveStatue", headerName: "Active"},
  { width: 300, field: "createBy", headerName: "Created By" },
  {
    field: "createDate", headerName: "Create Date", width: 350, cellRenderer: (data) => {
        return moment(data.value).format('DD/MM/YYYY');
    }
  },
  // { field: "editBy", headerName: "Edited By" },
  // { field: "oldEditDate", headerName: "Edited Date" },
  // { field: "uomId", headerName: "UOM Id" ,type: 'numericColumn'},
],
vesselDepartmentHeaders:[
  { width: 250, field: "vesselDepartmentCode", headerName: "Vessel Department Code" },
  { width: 300, field: "vesselDepartmentName", headerName: "Vessel Department Name" },
  { width: 320, field: "remarks", headerName: "Remarks"},
  { width: 120, field: "isActiveStatue", headerName: "Active"},
  { width: 250, field: "createBy", headerName: "Created By" },
  { width: 200, field: "createDate", headerName: "Created Date",cellRenderer: (data) => {
    return moment(data.value).format('DD/MM/YYYY');
} },
  // { width: 200, field: "newcreateDate", headerName: "Created Date" },
  // { field: "editBy", headerName: "Edited By" },
  // { field: "oldEditDate", headerName: "Edited Date" },
  // { field: "vesselDepartmentId", headerName: "Vessel Department Id",type: 'numericColumn' },
],
portMasterList: [
  { width:300, field: "portCode", headerName: "Port Code" },
  { width: 480, field: "portName", headerName: "Port Name" },
  { width: 150, field: "isActiveStatue", headerName: "Active"},
  { width: 300, field: "createBy", headerName: "Created By" },
  { width: 200, field: "createDate", headerName: "Created Date",cellRenderer: (data) => {
    return moment(data.value).format('DD/MM/YYYY')} },
  // { field: "editBy", headerName: "Edited By" },
  // { field: "oldEditDate", headerName: "Edited Date" },
  // { field: "portId", headerName: "Port Id",type: 'numericColumn' },
],
GSTMasterListHeaders:[
  { width: 150, field: "gstCode", headerName: "GST Code" },
  { width: 500, field: "gstName", headerName: "GST Name" },
  { width: 180, field: "gSTPercentage", headerName: "GST Percentage" },
  { width: 150, field: "isActiveStatue", headerName: "Active"},
  { width: 300, field: "createBy", headerName: "Created By" },
  { width: 200, field: "createDate", headerName: "Created Date",cellRenderer: (data) => {
    return moment(data.value).format('DD/MM/YYYY')} },
  // { field: "editBy", headerName: "Edited By" },
  // { field: "oldEditDate", headerName: "Edited Date" },
  // { field: "gstId", headerName: "GST ID",type: 'numericColumn' },
],
modelListHeaders: [
  { field: "modelType", headerName: "Model", width: 250 },
  { field: "serialNo", headerName: "Serial No", width: 250 },
  // { field: "bargeName", headerName: "Vessel", width: 250 },
  { field: "make", headerName: "Make", width: 250 },
  { width: 150, field: "isActiveStatus", headerName: "Active" },
  { width: 150, field: "yearManufactured", headerName: "Year Of Manufacture" },
  { field: "modelRemarks", headerName: "Remarks", width: 550 },
],  

sparePartsMasterListHeader:[
  { width: 400, field: "sparesCode", headerName: "Spares Code ",width: 250,tooltipField:"sparesCode",tooltipShowDelay: 0,},
  { width: 400, field: "partNo", headerName: "Part No ",width: 250,tooltipField:"partNo",tooltipShowDelay: 0,},
  { width: 400, field: "partName", headerName: "Part Name ",width: 350,tooltipField:"partName",tooltipShowDelay: 0,},
  { width: 120, field: "uomCode", headerName: "UOM",width: 150},
  { width:400, field: "remarks" , headerName: "Remarks",width: 350,tooltipField:"remarks",tooltipShowDelay: 0,},
  { width: 200, field: "createBy", headerName: "Created By",width: 150},
  { width: 200, field: "createDate", headerName: "Created Date",cellRenderer: (data) => {
    return moment(data.value).format('DD/MM/YYYY');
} },
  { width:150, field: "isActiveStatue" , headerName: "Active",width: 150},
  { width: 400, field: "equipmentName", headerName: "Equipment Name ",width: 250,tooltipField:"equipmentName",tooltipShowDelay: 0,},
  { width: 400, field: "modelType", headerName: "Model Type ",width: 250, tooltipField:"modelType",tooltipShowDelay: 0,},
  { width: 400, field: "make", headerName: "Model Make ",width: 250, tooltipField:"make",tooltipShowDelay: 0,},
],
  vendorCashClaimHeader: [
    {
      field: "itemNo",
      headerName: "Item NO",
      maxWidth: 100,
    },
    {
      field: "iMPACodeId",
      headerName: "IMPA Code*",
    },
    {
      field: "description",
      headerName: "Description",
    },
    {
      field: "mainCodeId",
      headerName: "GL Code*",
    },
    {
      field: "bargeId",
      headerName: "Vessel*",
    },
    {
      field: "uOMId",
      headerName: "UOM",
    },
    {
      field: "qty",
      headerName: "Qty*",
    },
    {
      field: "price",
      headerName: "Price*",
    },
    {
      field: "amt",
      headerName: "Amount",
    },
    {
      field: "remarks",
      headerName: "Remarks",

    }
  ],
  vendorClaimDependentField:{
    iMPACodeId:[
      {
      key: 'iMPACode',
      value: 'iMPACode'
      }, {
        key: 'description',
        value: 'label' 
      }
    ]
  },


  quoteCompare : [
    { key: "quotationCompareNo",  label: "QC No",_style: {width: "12%"}},
    { key: "requisitionNo", label: "Req No",_style: {width: "12%"} },  
    { key: "bargeName", label: "Vessel",_style: {width: "12%"} },
    { key: "referenceNo", label: "Ref No",_style: {width: "15%"}},
    { key: "remarks", label: "Remarks",_style: {width: "20%"} },
    { key: "requisitionDate", label: "Req date",_style: {width: "6%"} },
    // { key: "createBy", label: "Create By" },
    // { key: "editBy", label: "Edited By" },
    { key: "statusCode", label: "Status",_style: {width: "10%"} },
    { key: "processStatusDesc", label: "Process Status",_style: {width: "10%"} },
    // { key: "docCount", label: "Doc Count" },
    {
      key: "show_details",
      label: "",
      sorter: false,
      filter: false,
    },
  ],

  rfqItemsHeaderList : [
    { field: "vendorCode", headerName: "Vendor Code" },
    { field: "vendorName", headerName: "Vendor Name" },
    { field: "contact", headerName: "Contact" },
    { field: "email", headerName: "Email",tooltipField:"email",tooltipShowDelay: 0, },
    { field: "currencyCode", headerName: "Currency" },
    { field: "rFQRemarks", headerName: "Remarks",tooltipField:"rFQRemarks",tooltipShowDelay: 0,minWidth: 250 }
  ],

  popupColumnConfig:[    
    { field: "serialNo", headerName: "S.No", maxWidth: 80 },
    { field: "code", headerName: "Code" },
    { field: "description", headerName: "Description", minWidth: 400 },
    { field: "approvedQty", headerName: "Req Qty" },
    { field: "approvedUOMCode", headerName: "Req UOM" },
    {field: "mainCode", headerName: "GL Code", tooltipField:"mainCodeDescription",tooltipShowDelay: 0},
    { field: "remarks", headerName: "Remarks" } 
  ],

  AdmUserHeader: [
    { field: "userCode",headerName: "User Code"},
    { field: "userName",headerName: "User Name",},
    { field: "userGroupName",headerName: "User Group"},
    { field: "roleName",headerName: "Role",},
    { field: "subRoleName",headerName: "Sub-Role"},
    { field: "expDate",headerName: "Pwd.Exp.Date",},
    { field: "isActiveStatue",headerName: "Active"},
    { field: "createBy",headerName: "Create By"},
    { field: "CreateDate",headerName: "Create Date"},
    { field: "editBy",headerName: "Edit By"},
    { field: "EditDate",headerName: "Edit Date"},
  ],


  statusInfo :[
    {
      key: 'ProcessStatusInfoList',
      label: '',
      _style: { width: '1%' },
      sorter: false,
      filter: false
    },
    { key: "breakStatus", label: "Status",_style: {width: "10%"}},
    { key: "documentNo", label: "Doc NO",_style: {width: "10%"}},
    { key: "breakReference", label: "Ref NO",_style: {width: "12%"}},
    { key: "breakVendorName", label: "Vendor",_style: {width: "10%"}},
    { key: "breakSubmittedBy", label: "Sub By",_style: {width: "10%"}},
    { key: "FormattedSubmittedDate", label: "Sub Date",_style: {width: "10%"}},
    { key: "formattedTotalAmt", label: "Amt",_style: {width: "4%"}},
    { key: "currency", label: "Curr",_style: {width: "4%"}},
  ],

  statusInfoGrid :[
    { field: "seqNo", headerName: "S.NO"},
    // { field: "documentNo", headerName: "Doc NO"},
    { field: "process", headerName: "Process"},
    { field: "processBy", headerName: "Process By"},
    { field: "formatedDate", headerName: "Date"},
  ],
  processStatusInfo :[
    { key: "seqNo", label: "S.NO"},
    // { key: "documentNo", label: "Doc NO"},
    { key: "process", label: "Process"},
    { key: "processBy", label: "Process By"},
    { key: "formatedDate", label: "Date"},
  ],

  // AccessRights Field names
  accessRightsTable: [
    { key: "linkName", label: "Module"},
    { key: "isRead",label: "Is Read" },
    { key: "isWrite", label: "Is Write"},
    { key: "isUpdate", label: "Is Update"},
    { key: "isDelete", label: "Is Cancel"},
    { key: "isSubmit", label: "Is Submit"},
    { key: "isPrint", label: "Is Print"},
    { key: "isProcess", label: "Is Process"},
    { key: "isPost", label: "Is Post"},
    { key: "isApprove", label: "Is Approved"},
    { key: "isDefault", label: "Is Default"},    
  ],
  AccessRights_MASTERS:[
    { key: "linkName", label: "Module"},
    // style: { font: { sz: "24", bold: true } },
    { key: "isRead",label: "Is Read" },
    { key: "isWrite", label: "Is Write"},
    { key: "isUpdate", label: "Is Update"},
    { key: "isDelete", label: "Is Cancel"},
    { key: "isPrint", label: "Is Print"},
    { key: "isDefault", label: "Is Default"},  
  ],
  AccessRights_PMSPURCHASE_WORKORDER:[
    { key: "linkName", label: "Module"},
    { key: "isRead",label: "Is Read" },
    { key: "isWrite", label: "Is Write"},
    { key: "isUpdate", label: "Is Update"},
    { key: "isDelete", label: "Is Cancel"},
    { key: "isSubmit", label: "Is Submit"},
    { key: "isPrint", label: "Is Print"},
    { key: "isProcess", label: "Is Process"},
    { key: "isPost", label: "Is Post"},
    { key: "isDefault", label: "Is Default"},      
  ],
AccessRights_DASHBOARD:[
    { key: "linkName", label: "Module"},
    { key: "isRead",label: "Is Read" },
    { key: "isDefault", label: "Is Default"},      
  ],
  AccessRights_QUOTECOMPARE:[
    { key: "linkName", label: "Module"},
    { key: "isRead",label: "Is Read" },
    { key: "isWrite", label: "Is Write"},
    { key: "isUpdate", label: "Is Update"},
    { key: "isDelete", label: "Is Cancel"},
    { key: "isPrint", label: "Is Print"},
    { key: "isDefault", label: "Is Default"},      
  ],
  AccessRights_APPROVALCENTER:[
    { key: "linkName", label: "Module"},
    { key: "isRead",label: "Is Read" },
    { key: "isPrint", label: "Is Print"},
    { key: "isApprove", label: "Is Approved"},
    { key: "isDefault", label: "Is Default"},      
  ],
  AccessRights_ADMIN:[
    { key: "linkName", label: "Module"},
    { key: "isRead",label: "Is Read" },
    { key: "isWrite", label: "Is Write"},
    { key: "isUpdate", label: "Is Update"},
    { key: "isDelete", label: "Is Cancel"},
    { key: "isPrint", label: "Is Print"},
    { key: "isDefault", label: "Is Default"},      
  ],
  addNewVendorFields: [
    // { key: "serialNo", label: "S.No", _style: { width: "5%" } },
    { key: "contact", label: "Vendor PIC" },
    { key: "breakEmail", label: "Email" },
    { key: "mobileNo", label: "Mobile No" },
    { key: "telephoneNo", label: "Telephone No" },
    { key: "faxNo", label: "Fax No"},
    { key: "zipCode", label: "Zip Code"},
    // { key: "addressCode", label: "Address Code"},
    { key: "breakAddress1", label: "Address" },
    { key: "breakAddress2", label: "Address 2" },
    { key: "breakAddress3", label: "Address 3" },
    { key: "breakAddress4", label: "Address 4" },
    {key: "breakRemarks", label: "Remarks"},
    {
       key: "isDefault",
       label: "isDefault",
       sorter: false,
       filter: false,
    },
    {
      key: "Active",
      label: "Active",
      sorter: false,
      filter: false,
   },
    {
      key: "show_details",
      label: "",
      sorter: false,
      filter: false,
    },
  ],
};

export default fields;
